import styled from 'styled-components';

export const Hero = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.mainColors.darkPrpl};
  position: relative;
  height: 100vh;
  align-items: space-between;
`;

export const HeroMiddle = styled.div`
  margin: auto;
  max-width: 1200px;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 3;
  justify-content: space-around;
  align-items: baseline;
  height: max-content;
`;

export const HeroTitle = styled.h1`
  color: ${({ theme }) => theme.mainColors.hvid};
  width: max-content;
  max-width: 100%;
  font-size: 3rem;
  padding: 5px 0;
  margin: 0;
`;

export const HeroDes = styled.h2`
  color: ${({ theme }) => theme.mainColors.hvid};
  font-size: 2rem;
  line-height: 2.2rem;
  text-align: center;
  transparancy: 0.8;
  margin: 0;
`;

export const HeroImg = styled.img`
  max-width: 300px;
`;
